import templateUrl from '../views/modals/bulk-message-modal.tpl.html';
import RsvpBulkMessageModalController from '../controllers/modals/bulk-send/rsvp-bulk-message-modal';

export default function rsvpBulkMessageModalCreator($injector, recipientsStore, guestlist, extendedInformation) {
    extendedInformation = _.isObject(extendedInformation) ? extendedInformation : {
        recipientIdsOverride: []
    };

    return $injector.get('$uibModal').open({
        controller: RsvpBulkMessageModalController,
        controllerAs: 'vm',
        size: 'xlg',
        templateUrl,
        backdrop: 'static',
        windowClass: 'modal-fixed',
        keyboard: false,
        resolve: {
            extendedInformation: () => ({
                ...extendedInformation,
                recipientsStore,
                guestlist
            })
        }
    }).result;
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/helpers/rsvp-bulk-message-modal-creator.js